"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _orderDetail = _interopRequireDefault(require("@/components/orderDetail"));
var _orderSend = _interopRequireDefault(require("./orderSend"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _utils = require("@/utils");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'retailerOrderList',
  components: {
    detailsFrom: _orderDetail.default,
    orderSend: _orderSend.default
  },
  data: function data() {
    return {
      JavaMerInfo: JSON.parse(_jsCookie.default.get('JavaMerInfo')),
      RefuseVisible: false,
      RefuseData: {},
      supplierOrder: {},
      refundVisible: false,
      refundData: {},
      dialogVisibleJI: false,
      tableDataLog: {
        data: [],
        total: 0
      },
      tableFromLog: {
        page: 1,
        limit: 10,
        orderNo: 0
      },
      LogLoading: false,
      isCreate: 1,
      editData: null,
      dialogVisible: false,
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      tableFrom: {
        status: 'all',
        dateLimit: '',
        orderNo: '',
        page: 1,
        limit: 20,
        type: '0,99'
      },
      orderChartType: {},
      timeVal: [],
      fromList: this.$constants.fromList,
      fromType: [{
        value: '',
        text: '全部'
      }, {
        value: '0',
        text: '普通'
      }],
      selectionList: [],
      ids: '',
      orderids: '',
      cardLists: [],
      isWriteOff: (0, _utils.isWriteOff)(),
      proType: 0,
      active: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['订单号', '订单类型', '用户昵称', '实际支付', '支付方式', '订单状态', '下单时间'],
      columnData: ['订单号', '订单类型', '用户昵称', '实际支付', '支付方式', '订单状态', '下单时间'],
      isIndeterminate: true,
      orderDatalist: null
    };
  },
  mounted: function mounted() {
    this.getList();
    this.getOrderStatusNum();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 核销订单
    onWriteOff: function onWriteOff(row) {
      var _this = this;
      this.$modalPrompt('text', '核销码').then(function (V) {
        (0, _order.writeUpdateApi)({
          verifyCode: V
        }).then(function () {
          _this.$message.success('核销成功');
          _this.seachList();
        });
      });
    },
    resetFormRefundhandler: function resetFormRefundhandler() {
      this.refundVisible = false;
    },
    resetFormRefusehand: function resetFormRefusehand() {
      this.RefuseVisible = false;
    },
    resetForm: function resetForm(formValue) {
      this.dialogVisible = false;
    },
    seachList: function seachList() {
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 发送
    sendOrder: function sendOrder(row) {
      this.onSend(row);
    },
    //发货操作
    onSend: function onSend(row) {
      this.supplierOrder = row;
      this.$refs.send.modals = true;
      this.$refs.send.getList();
      this.$refs.send.orderProDetail(row.supplierOrderNo);
    },
    // 订单删除
    handleDelete: function handleDelete(row, idx) {
      var _this2 = this;
      if (row.isDel) {
        this.$modalSure().then(function () {
          (0, _order.orderDeleteApi)({
            orderNo: row.orderNo
          }).then(function () {
            _this2.$message.success('删除成功');
            _this2.tableData.data.splice(idx, 1);
          });
        });
      } else {
        this.$confirm('您选择的的订单存在用户未删除的订单，无法删除用户未删除的订单！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        });
      }
    },
    // 详情
    onOrderDetails: function onOrderDetails(data) {
      this.supplierOrder = data;
      this.$refs.orderDetail.getDetail(data.supplierOrderNo);
      this.$refs.orderDetail.getOrderInvoiceList(data.supplierOrderNo);
      this.$refs.orderDetail.dialogVisible = true;
    },
    getDetail: function getDetail(id) {
      var _this3 = this;
      this.loading = true;
      (0, _order.orderDetailApi)(id).then(function (res) {
        _this3.orderDatalist = res;
        _this3.loading = false;
      }).catch(function () {
        _this3.orderDatalist = null;
        _this3.loading = false;
      });
    },
    // 订单记录
    onOrderLog: function onOrderLog(id) {
      var _this4 = this;
      this.dialogVisibleJI = true;
      this.LogLoading = true;
      this.tableFromLog.orderNo = id;
      (0, _order.orderLogApi)(this.tableFromLog).then(function (res) {
        _this4.tableDataLog.data = res.list;
        _this4.tableDataLog.total = res.total;
        _this4.LogLoading = false;
      }).catch(function () {
        _this4.LogLoading = false;
      });
    },
    pageChangeLog: function pageChangeLog(page) {
      this.tableFromLog.page = page;
      this.onOrderLog();
    },
    handleSizeChangeLog: function handleSizeChangeLog(val) {
      this.tableFromLog.limit = val;
      this.onOrderLog();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    // 备注
    onOrderMark: function onOrderMark(row) {
      var _this5 = this;
      this.$modalPrompt('textarea', '订单备注', row.merRemark).then(function (V) {
        (0, _order.orderMarkApi)({
          remark: V,
          orderNo: row.supplierOrderNo
        }).then(function () {
          _this5.$message.success('操作成功');
          _this5.getList();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectionList = val;
      var data = [];
      this.selectionList.map(function (item) {
        data.push(item.orderNo);
      });
      this.ids = data.join(',');
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.timeVal = [];
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.tableFrom.page = 1;
      this.getList();
      this.getOrderStatusNum();
    },
    // 列表
    getList: function getList() {
      var _this6 = this;
      this.listLoading = true;
      (0, _order.orderListApi)(this.tableFrom).then(function (res) {
        _this6.tableData.data = res.list || [];
        _this6.tableData.total = res.total;
        _this6.listLoading = false;
        _this6.checkedCities = _this6.$cache.local.has('order_stroge') ? _this6.$cache.local.getJSON('order_stroge') : _this6.checkedCities;
      }).catch(function () {
        _this6.listLoading = false;
      });
    },
    // 获取各状态数量
    getOrderStatusNum: function getOrderStatusNum() {
      var _this7 = this;
      (0, _order.orderStatusNumApi)({
        dateLimit: this.tableFrom.dateLimit,
        type: this.tableFrom.type
      }).then(function (res) {
        _this7.orderChartType = res;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    exports: function exports() {
      var data = {
        dateLimit: this.tableFrom.dateLimit,
        orderNo: this.tableFrom.orderNo,
        status: this.tableFrom.status,
        type: this.tableFrom.type
      };
      (0, _order.supplierOrderExcelApi)(data).then(function (res) {
        window.open(res.fileName);
      });
    },
    renderHeader: function renderHeader(h) {
      var _this8 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this8.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    //打印小票
    onOrderPrint: function onOrderPrint(data) {
      var _this9 = this;
      (0, _order.orderPrint)(data.orderNo).then(function (res) {
        _this9.$modal.msgSuccess('打印成功');
      }).catch(function (error) {
        _this9.$modal.msgError(error.message);
      });
    }
  }
};